import React, { useState, useRef, useEffect } from 'react';
import { getDocumentation, GetDocumentationInput } from '../../../../actions/get-documentation.action';

interface DocumentNode {
    name: string;
    path?: string; // solo i file hanno un path
    children?: DocumentNode[];
}

interface DocumentEntry {
    DocumentName: string;
    DocumentPosition: string;
}

const CataloguesButton: React.FC<{ label: string; context: any }> = ({ label, context }) => {
    const [links, setLinks] = useState<DocumentNode[]>([]);
    const [treeNodeExpanded, setTreeNodeExpanded] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    function buildTree(documents: DocumentEntry[]): DocumentNode[] {
        const root: DocumentNode[] = [];

        for (const doc of documents) {
            const parts = doc.DocumentName.split('/');
            let currentLevel = root;

            parts.forEach((part, index) => {
                let existing = currentLevel.find(node => node.name === part);

                if (!existing) {
                    existing = {
                        name: part
                    };

                    if (index === parts.length - 1) {
                        existing.path = doc.DocumentPosition;
                    } else {
                        existing.children = [];
                    }

                    currentLevel.push(existing);
                }

                if (existing.children) {
                    currentLevel = existing.children;
                }
            });
        }

        return root;
    }

    const treeNodeClickHandler = () => {
        setTreeNodeExpanded(prev => !prev);
    };

    const getDocument = async () => {
        try {
            const input: GetDocumentationInput = new GetDocumentationInput();
            const genericDocumentation = await getDocumentation(input, context.actionContext);
            const newLinks = genericDocumentation.blobs.map((blob: { DocumentName: string; DocumentPosition: string }) => ({
                DocumentName: blob.DocumentName || '',
                DocumentPosition: blob.DocumentPosition || ''
            }));

            setLinks(buildTree(newLinks));
        } catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    };

    useEffect(() => {
        getDocument();
    }, []);

    const TreeNode: React.FC<{ node: DocumentNode }> = ({ node }) => {
        const [expanded, setExpanded] = useState(false);

        const isFolder = !!node.children;

        const toggle = () => {
            if (isFolder) setExpanded(prev => !prev);
        };

        return (
            <div style={{ marginLeft: '1rem', paddingRight: '0.5rem' }}>
                <div
                    onClick={toggle}
                    style={{
                        cursor: isFolder ? 'pointer' : 'default',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <span className={`ms-sub-header__menu-container__left-buttons__catalogues-button__catalogues-submenu__tree-node`}>
                        {isFolder ? (expanded ? '📂' : '📁') : '📄'}
                    </span>
                    {isFolder ? (
                        <span
                            className={`ms-sub-header__menu-container__left-buttons__catalogues-button__catalogues-submenu__tree-node-folder`}
                        >
                            {node.name}
                        </span>
                    ) : (
                        <a
                            href={node.path}
                            target='_blank'
                            rel='noopener noreferrer'
                            className={`ms-sub-header__menu-container__left-buttons__catalogues-button__catalogues-submenu__node`}
                        >
                            {node.name}
                        </a>
                    )}
                </div>
                {isFolder && expanded && node.children && (
                    <div style={{ marginLeft: '1rem', borderLeft: '1px solid #ddd', paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                        {node.children.map((child, i) => (
                            <TreeNode key={i} node={child} />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    const TreeView: React.FC<{ nodes: DocumentNode[] }> = ({ nodes }) => {
        return (
            <div>
                {nodes.map((node, i) => (
                    <TreeNode key={i} node={node} />
                ))}
            </div>
        );
    };

    return (
        <div className='ms-sub-header__menu-container__left-buttons__catalogues-button' ref={menuRef} style={{ padding: '1rem' }}>
            <button onClick={() => treeNodeClickHandler()}>{label}</button>
            {treeNodeExpanded && (
                <div className={`ms-sub-header__menu-container__left-buttons__catalogues-button__catalogues-submenu`}>
                    <TreeView nodes={links} />
                </div>
            )}
        </div>
    );
};

export default CataloguesButton;
